import {mapState} from 'vuex'
import storageUtils from '../../util/storageUtils'
export default {
  props: {
    gridId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      accountObj: state => state.account
    }),
    wrapperKey () {
      return `${this.accountObj.loginId || '_anonymous'}$$grid_wrapper_${this.gridId}`
    }
  },
  methods: {
    setWrapper (key, value) {
      storageUtils.setItem(this.wrapperKey, key, value)
    },
    getWrapper (key) {
      return storageUtils.getItem(this.wrapperKey, key)
    }
  }
}
